import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { loadMohave } from "./utils/loadMohave";
import { loadRemixicon } from "./utils/loadRemixicon";
import { useThemeStore } from "./store/useThemeStore";

// Apply ck-theme flash-guard cache (or default) once at startup.
// Authoritative theme loads from preferences API after auth (see App.js).
void useThemeStore.getState().initTheme();

loadRemixicon();
if (typeof requestIdleCallback === "function") {
  requestIdleCallback(() => loadMohave());
} else {
  setTimeout(loadMohave, 1);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
